export const technicalSkills = [
    {
      title: "React",
    },
    {
      title: "C#",
    },
    {
      title: "Javascript"
    },
    {
      title: "Typescript",
    },
    {
        title: "Webpack",
    },
    {
        title: "React Profiler",
      },
  ];
  export const workexperience = [
    {
      company : 'Geotab Inc',
      jobTitle: "Full-time : Web Developer Intern",
      location: "Oakville, Ontario",
      duration: 'Jan 2021 - Present',
      websiteLink: 'https://www.geotab.com/'
    },
    {
      company : 'DigiTechYard Pvt. Ltd',
      jobTitle: "Full-time : Software Engineer",
      location: "Gujarat, India",
      duration: 'Nov 2018 - Nov 2019',
      websiteLink: 'https://www.dtyard.com/'
    },
    {
      company : 'Maruti Techlabs Pvt. Ltd',
      jobTitle: "Full-time : Software Engineer",
      location: "Gujarat, India",
      duration: 'May 2017 - Oct 2018',
      websiteLink: 'https://marutitech.com/'
    },
    {
      company : 'Maruti Techlabs Pvt. Ltd',
      jobTitle: "Full-time : Software Engineer Intern",
      location: "Gujarat, India",
      duration: 'Dec 2016 - Mar 2017',
      websiteLink: 'https://marutitech.com/'
    },
  ];

export const skills = [
    {
      title: "React Reserve",
      subtitle: "MERN Stack",
      description:
        "Lorem ipsum dolor sit amet consectetur adipisicing elit. Praesentium dolore rerum laborum iure enim sint nemo omnis voluptate exercitationem eius?",
      image: "./project-1.gif",
      link: "https://reactbootcamp.com",
    },
    {
      title: "React Tracks",
      subtitle: "React and Python",  
      description:
        "Lorem ipsum dolor sit amet consectetur adipisicing elit. Praesentium dolore rerum laborum iure enim sint nemo omnis voluptate exercitationem eius?",
      image: "./project-2.gif",
      link: "https://reedbarger.com",
    },
    {
      title: "DevChat",
      subtitle: "React and Firebase",
      description:
        "Lorem ipsum dolor sit amet consectetur adipisicing elit. Praesentium dolore rerum laborum iure enim sint nemo omnis voluptate exercitationem eius?",
      image: "./project-3.gif",
      link: "https://jsbootcamp.com",
    },
    {
      title: "Epic Todo App",
      subtitle: "React Hooks",
      description:
        "Lorem ipsum dolor sit amet consectetur adipisicing elit. Praesentium dolore rerum laborum iure enim sint nemo omnis voluptate exercitationem eius?",
      image: "./project-4.gif",
      link: "https://pythonbootcamp.com",
    },
  ];